import {
  OrderLinesWithJobsDataRow,
  SimulationHqDataRow,
} from '@warebee/shared/dataset-queries';
import { useTranslation } from 'react-i18next';
import { ColumnConfig } from '../components/DatasetTable';
import useOrderSetDataTableConfigBase from '../orders/useOrderSetDataTableConfigBase';

function useOrderLinesWithJobsDataTableConfig(): ColumnConfig<OrderLinesWithJobsDataRow>[] {
  const { t } = useTranslation('dataset');

  const ordersFieldSkip: Set<string> = new Set(['cumulativePercentRank']);

  const orderSetFields = useOrderSetDataTableConfigBase().filter(
    f => !ordersFieldSkip.has(f.field),
  ) as ColumnConfig<Partial<SimulationHqDataRow>>[];

  const columnsConfig: ColumnConfig<OrderLinesWithJobsDataRow>[] = [
    ...(orderSetFields as ColumnConfig<OrderLinesWithJobsDataRow>[]),
    {
      field: 'jobsIds',
      title: t`BatchId`,
      hasFilter: true,
    },
  ];

  return columnsConfig;
}
export default useOrderLinesWithJobsDataTableConfig;
